import { Injectable } from '@angular/core';
import { Query, Store, StoreConfig } from '@datorama/akita';
import { produce } from 'immer';
import { CsSetupSection } from '../charging-stations-section.model';


export interface CsSetupSectionsState {
  csSetupSections: CsSetupSection[];
}

@Injectable({ providedIn: 'root' })
export class CsSetupSectionsQuery extends Query<CsSetupSectionsState> {
  constructor(protected store: CsSetupSectionsStore) { super(store); }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'csSetupSectionsState', producerFn: produce })
export class CsSetupSectionsStore extends Store<CsSetupSectionsState> {
  constructor() {
    super({ csSetupSections: [] });
  }
}


